import React from 'react';
import EducationIcom from '../Assets/education_icon.png'; // Ruta a la imagen de la computadora
import educationData from '../Data/Education.json'; // Asegúrate de tener la ruta correcta al componente
import { EducationItem } from '../componets/EducationItem';
import './Education.css';

import { Fotter } from '../componets/Fotter';
export const Education = () => {
  return (
    <>
   
    <div >
    
      <div className='education-container'> 

        <img src={EducationIcom} alt="EducationIcon" className="EducationIcon" />
        <div className='education-items'>
          {educationData.map((item, index) => (
            <EducationItem
              key={index}
              date={item.date}
              school={item.school}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </div>
    <Fotter/>
    </>
  );
};